import React from 'react';
import {
    SimpleShowLayout,
    TextField,
    Show,
} from 'react-admin';

const VendorShow = (props: any) => {
    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source='id' />
                <TextField source='name' />
                <TextField source='phoneNumber' />
                <TextField source='category' />
            </SimpleShowLayout>
        </Show>
    );
};

export default VendorShow;